import { InputNumber } from 'antd'
import _ from 'lodash'

import Styled from './styled'

export default function MyInputNumber(props) {
  const inputNumberProps = {
    formatter: (value) => {
      const [integer, decimal] = _.split(value, '.')
      const integerFormat = `${integer}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return `${integerFormat}.${decimal || 0}`
    },
    parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
    ...props,
  }

  return (
    <Styled className="input-number-component">
      <InputNumber {...inputNumberProps} />
    </Styled>
  )
}
